import React, {} from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Example } from 'components';
import i18n from 'i18next';

const Container = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 20px;
`;

const ExmapleBlockHotelSearch = () => {
	const { t } = useTranslation();

	return (
		<>

			<Container>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/HotelSearchRequest.xsd'} title={t('Схема запроса')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/xsd/HotelSearchResponse.xsd'} title={t('Схема ответа')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelSearchRequest.xml'} title={t('Пример запроса') + ' ' + t('Без дополнительных кроватей')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelSearchResponse.xml'} title={t('Пример успешного ответа') + ' ' + t('Без дополнительных кроватей')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelSearchRequest2.xml'} title={t('Пример запроса') + ' ' + t('С дополнительными кроватями')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelSearchResponse2.xml'} title={t('Пример успешного ответа') + ' ' + t('С дополнительными кроватями')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelSearchRequest3.xml'} title={t('Пример запроса') + ' ' + t('Поиск по объектам')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelSearchResponse3.xml'} title={t('Пример успешного ответа') + ' ' + t('Поиск по объектам')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelSearchRequest4.xml'} title={t('Пример запроса') + ' ' + t('Поиск по списку гостиниц')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelSearchResponse4.xml'} title={t('Пример успешного ответа') + ' ' + t('Поиск по списку гостиниц')}/>

				<Example url={'https://images.acase.ru/sjas/xmlgw/sample/'+ i18n.language +'/HotelSearchResponseError.xml'} title={t('Пример ответа с ошибкой')}/>

			</Container>
		</>
	);
};

export default ExmapleBlockHotelSearch;